import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKirbyComponent } from './simple-icons-kirby.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKirbyComponent ],
    exports:      [ SimpleIconsKirbyComponent ],
    bootstrap:    []
})
export class SimpleIconsKirbyModule {}
